export function IconCancel() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
            <path d="M3.282 3.282a.961.961 0 0 0 0 1.359L4.64 6 3.28 7.36a.961.961 0 1 0 1.36 1.358L6 7.36l1.36 1.36a.961.961 0 1 0 1.358-1.36L7.36 6l1.36-1.36a.961.961 0 1 0-1.36-1.358L6 4.64 4.64 3.28a.961.961 0 0 0-1.358 0z"/>
        </svg>
    );
}
